export default __webpack_public_path__ + "static/media/chess-red-white-pieces(reduced).42a86479.webp";